import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-0 rounded-3 bg-white position-relative z-1 mb-4 p-25 popular-rooms-bg" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "mt-3 mb-6 fs-16 fw-semibold hover" }
const _hoisted_4 = { class: "text-body" }
const _hoisted_5 = { class: "fw-semibold" }
const _hoisted_6 = { class: "position-absolute top-0 end-0 m-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4" }, [
      _createElementVNode("h5", { class: "mb-0" }, "Popular Rooms"),
      _createElementVNode("div", { class: "" }, [
        _createElementVNode("div", { class: "swiper-pagination-popular-rooms" })
      ])
    ], -1)),
    _createVNode(_component_Swiper, {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: false,
      preventClicks: true,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: '.swiper-pagination-popular-rooms',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        576: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
        1440: {
          slidesPerView: 4,
        },
        1850: {
          slidesPerView: 4,
        },
      },
      modules: _ctx.modules,
      class: "popular-rooms-slide"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, index) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
            default: _withCtx(() => [
              _createVNode(_component_RouterLink, {
                to: `/hotel/room-details/${room.id}`,
                class: "text-decoration-none position-relative d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: room.image,
                    class: "rounded-3",
                    alt: room.name
                  }, null, 8, _hoisted_2),
                  _createElementVNode("h3", _hoisted_3, _toDisplayString(room.name), 1),
                  _createElementVNode("span", _hoisted_4, [
                    _cache[0] || (_cache[0] = _createTextVNode(" Code ", -1)),
                    _createElementVNode("strong", _hoisted_5, _toDisplayString(room.code), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`d-inline-block ${room.status.class} border px-2 rounded-pill ${room.status.textClass} fs-12 fw-medium`)
                    }, _toDisplayString(room.status.text), 3)
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}